export default __webpack_public_path__ + "static/media/817w3.4692089c.png";